module.exports = __webpack_public_path__ + "static/360view_24m-6082533faabd0638fec0ccd23870d53c.jpg";